import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Ids of users who have blocked the current user (one-way DM block). Lets the
 * DM composer show a "you're blocked" notice instead of an input. Separate
 * from useBlockedUsers (who *I* blocked) — different direction, different key.
 */
export const BLOCKED_BY_QUERY_KEY = ['me', 'blockedBy'] as const;

export function useBlockedBy(): {
  blockedByIds: Set<string>;
  isBlockedBy: (userId: string) => boolean;
} {
  const query = useQuery({
    queryKey: BLOCKED_BY_QUERY_KEY,
    queryFn: () => api.listBlockedBy(),
  });
  const ids = new Set(query.data?.userIds ?? []);
  return { blockedByIds: ids, isBlockedBy: (userId: string) => ids.has(userId) };
}
